import Vue from "vue";
import Vuex from "vuex";
import "../assets/css/site.less";
import "../assets/css/font/iconfont.css";
import "../assets/css/font/iconfont.js";

import { wxInit } from "./util/wxHelper";
import { Lazyload, Empty } from 'vant';
import App from "./App";
import store from "./store";
import { router } from "./router";
import VueLogger from "vuejs-logger";
// import Vconsole from 'vconsole';
import {
  Popup,
  Icon,
  Button,
  overlay,
  checkbox,
  Toast
} from "vant";
// import { signaRHub } from "./util/signalR";
// const vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.use(Vuex);
Vue.use(Empty);


// const isProduction = process.env.NODE_ENV === "production"&& new Vconsole();
const isProduction = process.env.NODE_ENV === "production";
const debugOptions = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};
Vue.use(VueLogger, debugOptions);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue
  .use( Popup )
  .use( Icon )
  .use( Button )
  .use( overlay )
  .use( checkbox )
  .use( Toast )
import VueProgressBar from "vue-progressbar";
const options = {
  color: "#07c160",
  failedColor: "#874b4b",
  thickness: "2px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};
Vue.use(VueProgressBar, options);
wxInit();
// Vue.prototype.$signalConnection = null;
// if (store.getters.userInfo != undefined && store.getters.userInfo != null) {
//   Vue.prototype.$signalConnection = signaRHub(store.getters.userInfo.userId);
// }
let _vue = new Vue({
  router,
  el: "#app",
  store,
  render: (h) => h(App),
}).$mount("#app");

export default _vue;
